
import { Vue, Component, Ref } from 'vue-property-decorator';
import { FormModel } from 'ant-design-vue';

@Component({})
export default class FillFollowModal extends Vue {
  visible = false;

  title = '填写跟进记录';

  @Ref()
  readonly ruleFormModel!: FormModel;

  shopData: any = {};

  ruleForm = {
    pass: '',
    checkPass: '',
    age: '',
  };

  rules = {
    pass: [{ required: true, message: '请输入密码', trigger: 'blur' }],
    checkPass: [{ required: true, message: '请输入确认密码', trigger: 'blur' }],
    age: [{ type: 'number', message: '请输入正确的年龄', trigger: 'blur' }],
  };

  layout = {
    labelCol: { span: 4 },
    wrapperCol: { span: 14 },
  };

  submitForm() {
    this.ruleFormModel.validate((valid: boolean) => {
      if (valid) {
        // alert('submit!');
      } else {
        return false;
      }
    });
  }

  resetForm() {
    this.ruleFormModel.resetFields();
    this.visible = false;
  }

  init(value: any) {
    this.visible = true;
    this.shopData = value;
    this.title = `填写跟进记录-${this.shopData.shop_name}`;
  }
  handleCancel() {
    this.visible = false;
  }
  handleOk() {
    this.visible = false;
  }
}
